import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DienstplanFunktionsbereichUi} from './dienstplan.model.ui';
import {ModuleState, PageState} from './dienstplan.reducer';
import {DienstplanEintrag2, DienstplanFunktionsbereich2} from '../../../../clients/veranstaltungen-dienstplan';

export const getModuleState = createFeatureSelector<ModuleState>('DienstplanPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getDienstplanFunktionsbereiche = createSelector(getPageState, (state: PageState) => state.dienstplanFunktionsbereiche);
export const getUiZeigeDienstplanFunktionsbereicheLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeDienstplanFunktionsbereicheLaden);
export const getUiZeigeDienstplanFunktionsbereicheLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeDienstplanFunktionsbereicheLadefehler);

export const getDienstplanFunktionsbereicheGefiltert = createSelector(getPageState, (state: PageState) => {
    const dienstplanFunktionsbereichGefiltert = [];
    let filterString = '';

    if (state.filterString != null) {
        filterString = state.filterString;
    }
    if (state.dienstplanFunktionsbereiche != null &&  state.dienstplanFunktionsbereiche.length > 0) {
        state.dienstplanFunktionsbereiche.forEach((fb: DienstplanFunktionsbereich2) => {
            // Filter nach Typ
            let elementeFilterTyp = [];
            if (!(!state.kontakteAnzeigen && !state.benutzerAnzeigen)) {
                elementeFilterTyp = fb.elemente.filter((item: DienstplanEintrag2) => {
                    return state.kontakteAnzeigen && state.benutzerAnzeigen
                        || state.kontakteAnzeigen && !state.benutzerAnzeigen && (item !== null && item.typ.toUpperCase() === 'KONTAKT')
                        || !state.kontakteAnzeigen && state.benutzerAnzeigen && (item !== null && item.typ.toUpperCase() !== 'KONTAKT');
                });
            }

            // Filter nach Suche
            const elemente = elementeFilterTyp.filter((item: DienstplanEintrag2) => {
                return filterString === ''
                    || filterString === null
                    || (item !== null && item.display_text !== null && item.display_text.toLowerCase().indexOf(filterString.toLowerCase()) !== -1)
                    || (item !== null && item.titel !== null && item.titel.toLowerCase().indexOf(filterString.toLowerCase()) !== -1);
            });


            const dienstplanFunktionsbereichItem = <DienstplanFunktionsbereichUi> {
                funktionsbereich_titel: fb.funktionsbereich_titel,
                funktionsbereich_id: fb.funktionsbereich_id,
                elemente,
                open: state.inaktiveFunktionsbereiche.findIndex(x => x === fb.funktionsbereich_id) === -1
            };

            if (dienstplanFunktionsbereichItem.elemente.length > 0 || filterString === '') {
                dienstplanFunktionsbereichGefiltert.push(dienstplanFunktionsbereichItem);
            }
        });
    }

    return dienstplanFunktionsbereichGefiltert;
});

export const getBenutzerAnzeigen = createSelector(getPageState, (state: PageState) => state.benutzerAnzeigen);
export const getKontakteAnzeigen = createSelector(getPageState, (state: PageState) => state.kontakteAnzeigen);
